import React from 'react';

type Props = {
  width?: string,
  height?: string,
  stroke?: string,
  className?: string,
};

const Dice = ({
  width,
  height,
  stroke,
  className,
}: Props) => (
  <svg
    fill="none"
    width={width}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.232 8.052V3.947a.769.769 0 0 0-.382-.664L6.196 1.156a1.153 1.153 0 0 0-1.16 0L1.382 3.284A.77.77 0 0 0 1 3.947v4.105a.77.77 0 0 0 .382.665l3.654 2.126a1.154 1.154 0 0 0 1.16 0L9.85 8.717a.769.769 0 0 0 .382-.665Z"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m1.121 3.548 4.496 2.644 4.496-2.644M5.617 11V6.19"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.616 3.884c.319 0 .577-.173.577-.385 0-.213-.258-.385-.577-.385-.319 0-.577.172-.577.385 0 .212.258.385.577.385ZM4.463 7.539c.212 0 .384-.259.384-.577 0-.319-.172-.577-.384-.577-.213 0-.385.258-.385.577 0 .318.172.577.385.577ZM2.154 8.307c.213 0 .385-.258.385-.577 0-.318-.172-.577-.385-.577-.212 0-.384.259-.384.577 0 .319.172.577.384.577ZM6.771 7.539c.213 0 .385-.259.385-.577 0-.319-.172-.577-.385-.577-.212 0-.384.258-.384.577 0 .318.172.577.384.577ZM9.08 6.192c.212 0 .385-.258.385-.577 0-.319-.173-.577-.385-.577-.212 0-.385.258-.385.577 0 .319.173.577.385.577ZM6.771 9.654c.213 0 .385-.258.385-.577 0-.319-.172-.577-.385-.577-.212 0-.384.258-.384.577 0 .319.172.577.384.577ZM9.08 8.307c.212 0 .385-.258.385-.577 0-.318-.173-.577-.385-.577-.212 0-.385.259-.385.577 0 .319.173.577.385.577Z"
      fill={stroke}
    />
  </svg>
);

Dice.defaultProps = {
  width: 11,
  height: 12,
  stroke: '#0074d9',
  className: null,
};

export default Dice;
